import React from "react";
import Topbar from "../components/Topbar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Banner from "../components/ContactBanner";
import ContactSection from "../components/Contact/ContactSection";
import ContactForm from "../components/Contact/ContactForm";
import Map from "../components/Contact/Map";

const Home = () => {
  return (
    <main className="homepage">
      <Topbar />
      <Navbar />
      <Banner />
  <ContactSection />
  <ContactForm />
  <Map />
      <Footer />
    </main>
  );
};

export default Home;
